import { useForm } from "react-hook-form";
import UserForm from "./_userRoleForm";
import { IUserRoleCreateProps, IUserRoleFormInput } from "./UserRole.model";
import { userRoleService } from "../../service/UserRole/userRole.service";

const UserCreate = ({
  setUserRoleDialog,
  loadUserRoles,
}: IUserRoleCreateProps) => {
  const methods = useForm<IUserRoleFormInput>({
    defaultValues: {
      name: "",
    },
  });

  const { setError } = methods;

  const onSubmit = async (data: IUserRoleFormInput) => {
    try {
      await userRoleService.create(data);
      loadUserRoles();
      setUserRoleDialog(false);
    } catch (err: any) {
      if (err.response?.data) {
        const errors = err.response.data;

        Object.keys(errors).forEach((key) => {
          setError(key as keyof IUserRoleFormInput, {
            type: "server",
            message: Array.isArray(errors[key]) ? errors[key][0] : errors[key],
          });
        });
      }
    }
  };

  return <UserForm methods={methods} onSubmit={onSubmit} isEdit={false} />;
};

export default UserCreate;
